import { createPinia } from 'pinia';

export const pinia = createPinia();

export { useUIStore } from './useUIStore';
export { useAuthStore } from './useAuthStore';
export { useCheckoutStore } from './useCheckoutStore';
